import { render, staticRenderFns } from "./simPro.vue?vue&type=template&id=436599c1&"
import script from "./simPro.vue?vue&type=script&lang=ts&"
export * from "./simPro.vue?vue&type=script&lang=ts&"
import style0 from "./simPro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports